import { render, staticRenderFns } from "./WorkflowSection.vue?vue&type=template&id=56c74c14&scoped=true"
import script from "./WorkflowSection.vue?vue&type=script&lang=js"
export * from "./WorkflowSection.vue?vue&type=script&lang=js"
import style0 from "./WorkflowSection.vue?vue&type=style&index=0&id=56c74c14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c74c14",
  null
  
)

export default component.exports